import React from 'react'
import { Typography, Link } from '@mui/material'
import Alert, { AlertTitle } from '../alert'
import { useExternalApp } from '../../hooks'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(() => ({
  link: {
    cursor: 'pointer'
  }
}))

const NotAuthenticatedAlert = () => {
  const classes = useStyles()
  const { getMtUrl } = useExternalApp()
  const testAttr = suffix => `not-authenticated-alert-${suffix}`
  return (
    <Alert severity='error' showClose data-test={testAttr('container')}>
      <AlertTitle data-test={testAttr('title')}>Exclusive Content</AlertTitle>
      <Typography paragraph data-test={testAttr('text')}>
        You need to be a Mindtools member to access this resource.
      </Typography>
      <Link
        href={getMtUrl('join')}
        underline='always'
        variant='body1'
        color='inherit'
        className={classes.link}
        data-test={testAttr('action')}
      >
        Sign Up
      </Link>
    </Alert>
  )
}

export { NotAuthenticatedAlert }
